import axios from "axios";
import { baseURL } from "../config/api";

export const post_CreateWorkOrderForAppointment = (appointmentId: number, statusID: number, userId: number) => {
    return axios({
        url: `${baseURL}workOrders/CreateWorkOrderForAppointment?appointmentId=${appointmentId}&statusId=${statusID}&userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
    }).then(response => response.data);
}

export const put_UpdateWorkOrder = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}workOrders?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const getWorkOrder = (id: number) => {
    return getFetch(`workOrders/GetWorkOrdersReportByAppointmentId/${id}`)
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}